import { configuration } from 'api/utils/apiConfiguration'
import { customFetch } from 'api/utils/customFetch'
import { PaymentMethodControllerApi } from 'api/base/api.ts'

class BillingApi {
  api = new PaymentMethodControllerApi(configuration, configuration.basePath, customFetch)

  createSetupIntent = () => this.api.createSetupIntent()

  createCustomerSession = () => this.api.createCustomerSession()
}

export const billingApi = new BillingApi()